import React, {  useState } from "react";
import { Modal, Button } from 'antd';
import FormInput from "../../form-input/form-input.component";
import { connect } from "react-redux";
import { addExerciseFile } from "../../../actions/lectures.actions";
import { setAlert } from "../../../actions/alert";
import {PaperClipOutlined,FileImageOutlined} from "@ant-design/icons"

const AddFile = ({  exerciseID, addExerciseFile, setAlert ,correntCategory }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  }

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  

  const [Lesson, setLesson] = useState({
    title: "",
    discription: "",
    category: correntCategory,
    lesson: exerciseID,
  });

  const { title, discription, category, lesson } = Lesson;

  const [file, setfile] = useState("");

  const onChangefile = (e) => {
    console.log(lesson)
    setfile(e.target.files[0]);
  };
  const onChange = (e) => {
    setLesson({ ...Lesson, [e.target.name]: e.target.value });
  };
  const onSubmit = async (e) => {
    e.preventDefault();

    if (file === "" || title === "") {
      setAlert("ارجو إضافة ملف المحاضرة و اسم المحاضرة", "danger");
    } else {
      addExerciseFile(file, title, discription, category, lesson);

      setAlert("تمت الإضافة بنجاح ", "success");
      setLesson({
        title: "",
        discription: "",
        category: correntCategory,
        lesson: exerciseID,
      });
      setfile("");
    }
    setIsModalVisible(false);
  };

  return (
      <>
      <Button onClick={showModal} size="large">
        {category === "image" && <FileImageOutlined />}
        {category === "doc" && <PaperClipOutlined />}
      </Button>
      <Modal title="تحميل ملف" visible={isModalVisible} 
      footer={[
        <Button key="back" onClick={handleCancel}>
          إلغاء الامر
        </Button>,
        <Button key="submit" type="primary"  onClick={onSubmit}>
          حفط
        </Button>,
      ]}
      >
            <label htmlFor="file"> ادخل الملف المراد تحميله</label>
            <br />
            <input id="file" type="file" onChange={onChangefile} />

            <FormInput
              name="title"
              type="text"
              handleChange={onChange}
              value={title}
              label="عنوان   للملف"
              required
            />
      </Modal>
    </>
      
      
  );
};


export default connect(null, {
  addExerciseFile,
  setAlert,
})(AddFile);
